import { FeatherAlertCircle } from '@subframe/core';

type InlineFieldErrorProps = {
  message?: string | null;
};

export function InlineFieldError({ message }: InlineFieldErrorProps) {
  if (!message) {
    return null;
  }

  return (
    <div className="text-error-600 flex items-start gap-1.5 text-xs">
      <FeatherAlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
